import * as React from 'react';

declare var redirectUrl: string;
redirectUrl = redirectUrl.length > 0 ? redirectUrl : "/";

interface ExitProps {

}

const exit: React.SFC<ExitProps> = (props) => {
    return (
        <div className="cal-exit-container">
            <a href={redirectUrl} className="cal-exit"></a>
        </div>
    );
}

export default exit;


// WEBPACK FOOTER //
// ./app/calendar/views/exit.tsx